import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IWebHookEndpoint } from '@/shared/model/web-hook-endpoint.model';
import { ResourceInterface } from '@/shared/component/resource.interface';

const baseApiUrl = 'api/private/web-hook-endpoints';

export default class WebHookEndpointService implements ResourceInterface {
  public find(id: number): Promise<IWebHookEndpoint> {
    return new Promise<IWebHookEndpoint>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findWithSecret(id: number): Promise<IWebHookEndpoint> {
    return new Promise<IWebHookEndpoint>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}/secret`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public create(entity: IWebHookEndpoint): Promise<IWebHookEndpoint> {
    return new Promise<IWebHookEndpoint>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IWebHookEndpoint): Promise<IWebHookEndpoint> {
    return new Promise<IWebHookEndpoint>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public test(id: any, eventObj: any): Promise<IWebHookEndpoint> {
    return new Promise<IWebHookEndpoint>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/${id}/test`, eventObj)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

}
